// extracted by mini-css-extract-plugin
module.exports = {"roundIcon":"fq","disabled":"fr"};